import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  gap: 2rem;
  padding: 2rem;
  text-align: center;
  background-color: #f5f5f5;
`;

export const NotFoundIcon = styled.div`
  width: 120px;
  height: 120px;
  position: relative;
  margin-bottom: 1rem;

  &::before,
  &::after {
    content: "4";
    position: absolute;
    font-size: 120px;
    font-weight: bold;
    color: #9c27b0;
    opacity: 0.2;
  }

  &::before {
    left: -20px;
  }

  &::after {
    right: -20px;
  }

  & > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 120px;
    font-weight: bold;
    color: #9c27b0;
  }
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  color: #333;
  margin: 0;
`;

export const Message = styled.p`
  font-size: 1.2rem;
  color: #666;
  max-width: 600px;
  margin: 0;
`;

export const ButtonContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  gap: 1rem;
`;
